import type { IChatMessageWithState } from '@/stores/chat-session/types'
import type { IChatMessageHistory } from '@/api/chat-session/types'
import { MESSAGE_CONSTANTS } from '@/types/constants'

export function getRecentConversationHistory(
  messages: IChatMessageWithState[],
  maxTurns: number = MESSAGE_CONSTANTS.MAX_CONVERSATION_TURNS
): IChatMessageHistory[] {
  const conversationHistory: IChatMessageHistory[] = []
  const sentMessages = messages.filter(
    msg => msg.status === MESSAGE_CONSTANTS.STATUS.SENT
  )
  const maxMessages = maxTurns * MESSAGE_CONSTANTS.MESSAGES_PER_TURN
  const recentMessages = sentMessages.slice(-maxMessages)

  for (const message of recentMessages) {
    if (message.userMessage && message.userMessage.trim()) {
      conversationHistory.push({
        role: MESSAGE_CONSTANTS.ROLE.USER,
        content: message.userMessage.trim(),
      })
    }

    if (message.answer && message.answer.trim()) {
      conversationHistory.push({
        role: MESSAGE_CONSTANTS.ROLE.ASSISTANT,
        content: message.answer.trim(),
      })
    }
  }

  return conversationHistory
}
